import React, { useState } from 'react';
import Navbar from './components/Navbar';
import ProductCard from './components/ProductCard';
import Cart from './components/Cart';
import OrderConfirmationModal from './components/OrderConfirmationModal';
import products from './data/products';
import './App.css';

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  // Toggle cart visibility
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  // Add to cart function
  const addToCart = (product) => {
    // Check if product already exists in cart
    const existingItem = cartItems.find(item => item.id === product.id);
    
    if (existingItem) {
      // Update quantity if item exists
      setCartItems(
        cartItems.map(item =>
          item.id === product.id 
            ? { ...item, quantity: item.quantity + 1 } 
            : item
        )
      );
    } else {
      // Add new item to cart
      setCartItems([...cartItems, { ...product, quantity: 1 }]);
    }
  };

  // Update quantity
  const updateQuantity = (id, newQuantity) => {
    if (newQuantity < 1) {
      removeItem(id);
      return;
    }
    
    setCartItems(
      cartItems.map(item =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  // Remove item
  const removeItem = (id) => {
    setCartItems(cartItems.filter(item => item.id !== id));
  };

  // Clear cart
  const clearCart = () => {
    setCartItems([]);
  };

  // Open order modal
  const openOrderModal = () => {
    if (cartItems.length === 0) {
      alert("Your cart is empty! Add items before checking out.");
      return;
    }
    setIsOrderModalOpen(true);
  };

  // Close order modal
  const closeOrderModal = () => {
    setIsOrderModalOpen(false);
  };

  // Calculate total
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  // Get cart count
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="App">
      <Navbar cartCount={cartCount} toggleCart={toggleCart} />
      
      <div className="container">
        <header className="header">
          <h2>Fresh Eggs & Egg Products</h2>
          <p>High-quality eggs from free-range, healthy chickens</p>
        </header>
        
        <div className="products-grid">
          {products.map(product => (
            <ProductCard 
              key={product.id} 
              product={product} 
              addToCart={addToCart}
            />
          ))}
        </div>
      </div>
      
      <Cart 
        isOpen={isCartOpen}
        toggleCart={toggleCart}
        cartItems={cartItems}
        updateQuantity={updateQuantity}
        removeItem={removeItem}
        clearCart={clearCart}
        openOrderModal={openOrderModal}
      />
      
      <OrderConfirmationModal
        isOpen={isOrderModalOpen}
        onClose={closeOrderModal}
        cartItems={cartItems}
        total={calculateTotal()}
      />
      
      {isCartOpen && <div className="cart-overlay" onClick={toggleCart}></div>}
    </div>
  );
}

export default App;